import React from "react";
import StaticPage from "../components/StaticPage";

export default function LegalFramework() {
    return (
        <StaticPage
            kicker="Legal framework"
            title="Built on the Indian Copyright Act, 1957."
            lede="Every document on Silver Screen Xchange — Assignment Deed, Purchase Agreement, Transfer Record — is written directly against the enforceable sections of Indian copyright law."
            blocks={[
                { eyebrow: "Section 14", title: "Exclusive economic rights",
                  body: "Defines the reproduction, adaptation, translation, communication-to-public and commercial exploitation rights which we transfer in full to the buyer." },
                { eyebrow: "Section 18", title: "Assignment of copyright",
                  body: "Governs how copyright changes hands — our Deed follows the required form: identified work, rights assigned, territory, term, consideration, signatures." },
                { eyebrow: "Warranties", title: "What the creator guarantees",
                  body: "Sole ownership, no prior assignment, no infringement, chain-of-title complete. Explicitly warranted — with liability on the creator for misrepresentation." },
                { eyebrow: "Indemnity", title: "Protecting the buyer",
                  body: "Seven-year indemnity window from Silver Screen Xchange and the creator, covering third-party infringement claims and title challenges." },
                { eyebrow: "Jurisdiction", title: "Mumbai, Maharashtra",
                  body: "All disputes fall under the exclusive jurisdiction of the courts at Mumbai. Indian law, Indian courts, Indian enforcement." },
                { eyebrow: "E-sign", title: "Digitally legally binding",
                  body: "Signatures are captured with timestamped consent, user identification and contract fingerprinting — admissible under the IT Act, 2000." },
            ]}
            cta={{ label: "Open the marketplace", href: "/catalog" }}
        />
    );
}
